module.exports = __webpack_public_path__ + "static/media/token-logo.7c7a9236.png";